import { tokenManager } from '../../../lib/token-manager';
import { getUser } from '../../../redux/user';
import { history } from '../../../history';
import { routes } from '../../routes/routes-names';
import { AuthResponseType } from '../../../types/auth';
import { localStorageGetItem, localStorageSetItem } from '../../../components/storage/localStorageManager';
import { getHRMSUser } from '../../../redux/hrms';
import { encodeName } from '../../main';
import { AppDispatch } from '../../../redux';
import { useNavigate } from 'react-router-dom';

type SEOSearchQuery = {
    isCandidate: boolean;
    companyName?: string;
    candidateFirstName?: string;
    candidateLastName?: string;
    hashedId: string;
};

export async function goToRoom(
    data: AuthResponseType,
    dispatch: AppDispatch,
    navigate: ReturnType<typeof useNavigate>,
    isSEOSerachQuery?: SEOSearchQuery
) {
    // const close = document.querySelector('[data-close]') as HTMLButtonElement;
    tokenManager.setToken(data.resultObject.accessToken);
    localStorageSetItem('Email', data.resultObject.userEmail);
    const storageData = localStorageGetItem('unclaimed', false)!;

    if (storageData && storageData.claimedType === 'company') {
        localStorageSetItem('userApiToBeRun', true);
        await dispatch(getUser(navigate));
        navigate(routes.pendingOffers);
    } else if (isSEOSerachQuery?.hashedId) {
        const { isCandidate, candidateFirstName, candidateLastName, companyName, hashedId } = isSEOSerachQuery;

        if (isCandidate) {
            localStorageSetItem('userApiToBeRun', true);
            await dispatch(getUser(navigate));
            navigate(
                `/candidate/priv/${candidateFirstName?.replace(/\s+/g, '') || 'NA'}-${
                    candidateLastName?.replace(/\s+/g, '') || 'NA'
                }-${hashedId}?myProfileBack=true`
            );
        } else {
            localStorageSetItem('userApiToBeRun', true);
            await dispatch(getUser(navigate));
            navigate(
                `/company/priv/${encodeName(companyName?.replace(/\s+/g, '') || 'NA')}-${hashedId}?myProfileBack=true`
            );
        }
    } else {
        if (history.location.pathname === '/api-integrate') {
            localStorageSetItem('hrmsuserApiToBeRun', true);
            await dispatch(getHRMSUser());
            navigate(routes.apiIntegrate);
        } else {
            localStorageSetItem('userApiToBeRun', true);
            await dispatch(getUser(navigate));
            // close.click();
            navigate(routes.pendingOffers);
        }
    }
}
